import Reveal from '@/components/base/Reveal';
import { collections } from '@/mocks/home';
import SectionHeading from './SectionHeading';

interface CollectionZoneProps {
  notify: (msg: string) => void;
}

export default function CollectionZone({ notify }: CollectionZoneProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <SectionHeading
            kicker="素材内容合集"
            icon="ri-image-2-line"
            title="素材内容合集 · 图文并重"
            desc="设计、剪辑、字体、电商、音频与图表，六大方向的素材内容合集按份数标好，打开封面就知道里面有什么。"
            action={
              <button
                type="button"
                onClick={() => notify('已展开全部素材合集')}
                className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                全部合集
              </button>
            }
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <button
                type="button"
                onClick={() => notify(`正在进入「${item.name}」合集`)}
                className="group flex w-full cursor-pointer flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 text-left transition-colors hover:border-primary-300"
              >
                <div className="relative h-40 w-full overflow-hidden bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.name} 素材内容合集封面`}
                    title={`${item.name} - 爆瓜福利素材合集`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute right-3 top-3 rounded-sm bg-foreground-950/70 px-2 py-0.5 text-[11px] text-background-50">
                    {item.category}
                  </span>
                </div>
                <div className="flex items-center justify-between p-4">
                  <div className="min-w-0">
                    <h4 className="truncate font-medium text-foreground-950">{item.name}</h4>
                    <p className="mt-1 text-xs text-foreground-500">共 {item.count}</p>
                  </div>
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-up-line"></i>
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}